export default {"src":"/_next/static/media/vagrant-logo-mark_on-light.d46237d6.svg","height":72,"width":53,"blurWidth":0,"blurHeight":0};